<template>
  <app-form-select
    :datas="typeOfBusinesses"
    :labelText="labelText ?? $t('general.type_of_business')"
    :errorMessage="errorMessage"
    :serverMessage="serverMessage"
    :loading="loading"
    :showLabel="showLabel"
    :allowFilter="allowFilter"
    v-model="checkedValue"
    v-on:retry="getTypeOfBusinesses"
    v-on:valueSelected="onValueSelected"
  />
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    allowFilter: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Object,
      default: () => {},
    },
    country_id: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    country_id: function (newVal, oldValue) {
      this.getTypeOfBusinesses(newVal);
    },
    typeOfBusinesses(typeOfBusinesses) {
      if (this.$lodash.isEmpty(typeOfBusinesses)) {
        this.onValueSelected(null);
      }
    },
  },
  computed: {
    checkedValue: {
      get() {
        if (this.$lodash.isEmpty(this.typeOfBusinesses)) {
          return {};
        }
        return this.modelValue ?? [];
      },
      set(value) {
        this.onValueSelected(value);
      },
    },

    typeOfBusinesses() {
      return this.$store.getters["referenceStore/typeOfBusinesses"];
    },

    loading() {
      return this.$store.getters["referenceStore/loading"];
    },

    serverMessage() {
      return this.$store.getters["referenceStore/message"] ?? "";
    },
  },

  async mounted() {
    this.getTypeOfBusinesses();
  },

  methods: {
    async getTypeOfBusinesses() {
      this.$store.commit("referenceStore/resetState");
      this.$store.dispatch(
        "referenceStore/getTypeOfBusinesses",
        this.country_id
      );
    },

    onValueSelected(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>


